export function formatStatusLabel(status) {
  if (!status) return 'Unknown';
  return String(status)
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getProjectStatusClass(status) {
  if (!status) return 'status-unknown';
  const normalized = String(status).toLowerCase().replace(/\s+/g, '-');
  return `status-${normalized}`;
}
